<template lang="pug">
section#v-speakers.container
  h2 SPEAKERS
  h3 Special Lecture
  ul
    li: figure
      img(src='@/assets/speaker-s1.jpg')
      .name 林佳龍
      p 交通部部長
    li: figure
      img(src='@/assets/speaker-s2.jpg')
      .name 戴季全
      p 流線傳媒創辦人暨社長
    li: figure
      img(src='@/assets/speaker-s3.jpg')
      .name 林之晨
      p 台灣大哥大總經理暨 AppWorks 董事長
  h3 Session 1 Future of AI 智慧未來
  ul
    li: figure
      img(src='@/assets/speaker-1-1.jpg')
      .name 劉峻誠
      p Kneron 耐能智慧 創辦人暨執行長
    li: figure
      img(src='@/assets/speaker-1-2.jpg')
      .name 楊仲豪
      p Amazon Web Services 機器學習專業架構師
    li: figure
      img(src='@/assets/speaker-1-3.jpg')
      .name 林秀明
      p SysTalk.ai 昕力資訊創新暨 AI 產品發展處副總經理
    li: figure
      img(src='@/assets/speaker-1-4.jpg')
      .name 郭子銘
      p Kronos Research 量化研究員及交易員
  h3 Session 2 Future City 智慧生活
  ul
    li: figure
      img(src='@/assets/speaker-2-1.jpg')
      .name 姜家煒
      p GoShare 新事業總監
    li: figure
      img(src='@/assets/speaker-2-2.jpg')
      .name 王友光
      p 光禾感知科技 創辦人兼執行長
    li: figure
      img(src='@/assets/speaker-2-3.jpg')
      .name 黃謙智
      p 小智研發 創辦人暨執行長
  h3 Session 3 Future Manufacturing 未來製造
  ul
    li: figure
      img(src='@/assets/speaker-3-1.jpg')
      .name 林哲民
      p 台達電子 智能製造事業部總經理
  h3 Session 4 Future Democracy  網路民主對抗網路獨裁
  ul
    li: figure
      img(src='@/assets/speaker-4-2.jpg')
      .name 林飛帆
      p 民進黨 副秘書長
    li: figure
      img(src='@/assets/speaker-4-3.jpg')
      .name 林雨蒼
      p 自由軟體工作者、公民記者
    li: figure
      img(src='@/assets/speaker-4-4.jpg')
      .name 邱威傑
      p 臺北市議員
  h3 分場直播
  ul
    li: figure
      img(src='@/assets/speaker-l1.jpg')
      .name 吳昕霈
      p WeMo Scooter 創辦人暨執行長
    li: figure
      img(src='@/assets/speaker-l2.jpg')
      .name 林秀明
      p SysTalk.ai 昕力資訊創新暨 AI 產品發展處副總經理
    li: figure
      img(src='@/assets/speaker-l3.jpg')
      .name 張紹堯
      p 鉅怡智慧股份有限公司 策略長
</template>

<script>
export default {
  name: 'Speakers',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-speakers
  padding-bottom: 10px
  padding-top: 60px
h2
  +font(42px, white, null, 1.05px, 800, center)
  font-family: 'Montserrat Alternates'
  margin-bottom: 30px
h3
  +font(24px, #DFFF00, null, 1px, bold, center)
  margin-bottom: 40px
ul
  +flex(center)
  list-style-type: none
  margin-bottom: 50px
  li
    margin-bottom: 40px
    margin-right: 33px
    width: 215px
    &:nth-child(4n)
      margin-right: 0
    &:nth-child(4n + 1):nth-last-child(-n + 4)
      margin-bottom: 0
      & ~ li
        margin-bottom: 0
    figure
      img
        margin-bottom: 15px
        width: 100%
      .name
        +font(22px, black, null, 1.69px, bold)
        background-color: #DFFF00
        display: inline-block
        margin-bottom: 10px
        padding: 5px 8px
        &.en
          font-size: 18px
      p
        +font(15px, white, 20px, .15px)

@media (max-width: 1023px)
  #v-speakers
    padding-bottom: 20px
    padding-top: 30px
  h2
    +font(30px, null, null, .75px)
    margin-bottom: 20px
  h3
    +font(20px, null, null, .75px)
    margin-bottom: 30px
  ul
    flex-wrap: wrap
    margin-bottom: 0
    li
      margin-bottom: 30px
      margin-right: 0
      width: 50%
      &:nth-child(4n + 1):nth-last-child(-n + 4)
        margin-bottom: 30px
        & ~ li
          margin-bottom: 30px
      figure
        +flex(null, flex-start, column)
        margin-left: auto
        margin-right: auto
        max-width: 240px
        width: calc(100% - 40px)
        .name
          +font(16px, null, null, 1px)
          &.en
            font-size: 14px
        p
          +font(12px, null, 18px, .12px)
</style>
